
import Landing from "./Landing";

export default function CodeEditor() {
  return <Landing />;
}